import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { ShopTiles } from '../components/home/ShopTiles';
import { IngredientMarquee } from '../components/home/IngredientMarquee';
import { RitualSetFeature } from '../components/home/RitualSetFeature';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ProductSection } from '../components/shop/ProductSection';
import { collections } from '../data/collections';
import { productsForCollection } from '../utils/products';
export function Home() {
  const bestsellers = collections.find(c => c.slug === 'bestsellers');
  const top = bestsellers ? productsForCollection(bestsellers).filter(p => p.category !== 'sets').slice(0, 4) : [];
  return <>
      <HomeHero data-id="element-500" data-mp="2dj9ycibcegi3" />
      <ShopTiles data-id="element-501" data-mp="2dfm3nfu5vo1s" />
      <IngredientMarquee data-id="element-502" data-mp="3kvag2xnfsw0t" />
      <ProductSection title="Bestsellers" subtitle="Waar onze klanten steeds weer voor terugkomen." link={{
      to: '/collectie/bestsellers',
      label: 'Alle bestsellers'
    }} products={top} data-id="element-503" data-mp="3kw1yt7vxqz9o" />
      <RitualSetFeature data-id="element-504" data-mp="30vgo2oe633s4" />
      <ReviewsSection data-id="element-505" data-mp="30up1u46gmiei" />
    </>;
}